import { isValid, format } from "date-fns"
import Cookies from 'universal-cookie'
import { userData, userSession, impersonation } from './storage'
import dayjs from "dayjs"
import { cpfCnpjMask } from "./strings"

// ============================================================================
// LIB-1600 · FEATURE FLAG da sinalização de distrato na FICHA (chip, banner,
// etapa vermelha da régua). false = OCULTO. Trocar para true quando liberarem.
// (A coluna Distratos do quadro é controlada por um flag no backend.)
// ============================================================================
export const DISTRATO_VISIVEL = true

// ============================================================================
// LIB-1790 · FEATURE FLAG do "carregar mais" por coluna no quadro de Leads.
//
// false (hoje): cada "carregar mais" faz UMA requisição que traz a próxima
//   página de todas as colunas — exatamente o que a tela fazia antes.
// true: cada coluna busca a sua própria página, mandando `status_id`, e só a
//   coluna que o usuário rolou custa uma ida ao servidor.
//
// Trocar para true QUANDO o back passar a filtrar `list-record-ruler` por
// `status_id`. Ligar antes disso deixa a tela mais lenta, não mais rápida: o
// back montaria o quadro inteiro uma vez por coluna.
//
// SUP-643 — essa condição já foi cumprida (o back filtra por `status_id`), e
// mesmo assim a flag segue desligada, de propósito. O quadro tem UMA rolagem
// vertical para todas as colunas: descer mostra o pé de todas ao mesmo tempo.
// Com a flag ligada, cada coluna dispara a própria sequência de páginas assim
// que o seu pé aparece — várias requisições de uma vez, colunas carregando em
// ritmos diferentes, e coluna curta pedindo página atrás de página sozinha.
//
// Ligar isto só faz sentido junto de uma mudança no desenho: rolagem por
// coluna, e não uma rolagem para o quadro inteiro.
//
// O custo da rolagem estava no back, e foi atacado lá: montar o quadro fazia 46
// consultas por página (uma contagem, uma busca de fichas e cinco de
// relacionamento, por coluna) e passou a fazer 19. Quem mede isso de uma máquina
// de desenvolvimento, com o banco do outro lado da VPN, vê números bem maiores
// do que os de produção: cada ida ao banco custa ~88ms pela VPN, então o que
// pesa na medição é a QUANTIDADE de consultas, não o trabalho de cada uma.
// ============================================================================
export const KANBAN_COLUNA_SOB_DEMANDA = false


export const isTv = () => {

  let operatingSystem = 'Not known'

  if (window.navigator.userAgent.indexOf('TV') !== -1) {
    operatingSystem = 'TV'
  } else if (window.navigator.userAgent.indexOf('Win') !== -1) {
    operatingSystem = 'Windows OS'
  } else if (window.navigator.userAgent.indexOf('Mac') !== -1) {
    operatingSystem = 'MacOS'
  } else if (window.navigator.userAgent.indexOf('X11') !== -1) {
    operatingSystem = 'UNIX OS'
  } else if (window.navigator.userAgent.indexOf('Linux') !== -1) {
    operatingSystem = 'Linux OS'
  }

  return operatingSystem === 'TV'
}

export const storageItem = (
  type,
  name,
  value,
  useCookies = false,
  expireCookieDate = new Date((new Date()).getTime() + (86400000 * 365)) // 1 ano
) => {
  const cookies = new Cookies()

  let toReturn

  if (isTv() || useCookies) {
    if (type === 'set') {
      cookies.set(name, JSON.stringify(value), {path: '/', expires: expireCookieDate})
    } else if (type === 'get') {
      toReturn = cookies.get(name)
    } else if (type === 'remove') {
      cookies.remove(name, {expires: expireCookieDate})
    }
  } else {
    if (type === 'set') {
      window.localStorage.setItem(name, JSON.stringify(value))
    } else if (type === 'get') {
      if (window.localStorage.getItem(name)) {
        if (typeof window.localStorage.getItem(name) === 'string') {
          try {
            toReturn = JSON.parse(window.localStorage.getItem(name))
          } catch (e) {
            toReturn = (window.localStorage.getItem(name))
          }
        } else {
          toReturn = window.localStorage.getItem(name)
        }
      } else {
        toReturn = window.localStorage.getItem(name)
      }
    } else if (type === 'remove') {
      window.localStorage.removeItem(name)
    }
  }
  // }

  return toReturn
}

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

//conver de 11/22/2023 para 2024-22-11
  export const formatPtBrDateToIso = (date, mode = 'date') => {
    if (!date) return ''
  console.log(date)

    const parts = date.split('/')
    
    // Lógica para Mês e Ano (MM/YYYY)
    if (mode === 'month') {
      const [month, year] = parts
      if (!month || !year) return ''
      
      // Retorna o primeiro dia do mês para manter o padrão ISO (YYYY-MM-DD)
      // ou apenas YYYY-MM se o seu backend aceitar
      console.log(`${year}-${month.padStart(2, '0')}-01`)
      
      return `${year}-${month.padStart(2, '0')}-01`
    }

    // Lógica padrão (DD/MM/YYYY)
    const [day, month, year] = parts
    if (!day || !month || !year) return ''

    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  }

export const formatDateWithDaysAndHours = (dataStr) => {
  if (!dataStr) return
  const [data, hora] = dataStr.split(' ')
  const [ano, mes, dia] = data.split('-')
  return `${dia}/${mes}/${ano} - ${hora.slice(0, 5)}`
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => storageItem('get', userData)
export const getUserData = () => storageItem('get', userData)
export const getUserSession = () => storageItem('get', userSession)

export const normalizeNumber = (valor) => {
  if (valor === null || valor === '') return ''

  return String(valor)
    .replace(/\./g, '')
    .replace(/,/g, '.')
}

export const formatNumberPtBr = (
  value,
  options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
) => {
  if (value === null || value === '') return ''

  let number

  if (typeof value === 'number') {
    number = value
  } else {
    const stringValue = String(value)

    if (stringValue.includes(',')) {
      // formato pt-BR: 1.234,56
      number = Number(
        stringValue.replace(/\./g, '').replace(',', '.')
      )
    } else {
      // formato en-US: 1234.56 ou 2.00
      number = Number(stringValue)
    }
  }

  if (Number.isNaN(number)) return ''

  return new Intl.NumberFormat('pt-BR', options).format(number)
}

export const clearStorageUser = () => {
  storageItem('remove', userData)
  storageItem('remove', userSession)
  // Sem isso o aviso de "logado como" sobreviveria à expiração do token de impersonação
  // (o interceptor de 401 chama esta função) e reapareceria no próximo login.
  storageItem('remove', impersonation)
}

// ** Estado da impersonação ("Logar como usuário").
// Guarda apenas metadados devolvidos pelo backend — nunca um token.
export const getImpersonation = () => storageItem('get', impersonation)

export const setImpersonation = (data) => {
  if (data?.ativa) {
    storageItem('set', impersonation, data)
    return
  }

  storageItem('remove', impersonation)
}

export const saveLocalStorageUserData = (data, accessToken) => {
  const responseAbility = data?.user?.permissoes?.map(permission => {
    const action = []

    if (permission?.criacao === 1) {
      action.push('create')
    }

    if (permission?.leitura === 1) {
      action.push('read')
    }

    if (permission?.atualizacao === 1) {
      action.push('update')
    }

    if (permission?.delecao === 1) {
      action.push('delete')
    }

    if (permission?.menu === 1) {
      action.push('menu')
    }

    return {
      action,
      subject: permission.permissao?.nome
    }
  })

  const formattedUserData = {
    ...data?.user,
    ability: responseAbility
  }

  // Na TV o storage é cookie (limite ~4 KB): a foto em base64 (~8 KB) faria o
  // navegador descartar o cookie inteiro e o usuário cairia da sessão.
  if (isTv()) {
    delete formattedUserData.foto
  }

  storageItem('set', userData, formattedUserData)

  if (accessToken) {
    storageItem('set', userSession, accessToken)
  }

  return responseAbility
}

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return '/access-control'
  return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})

export const parseDate = (date, targetFormat = 'dd/MM/yyyy') => {
  if (!date) {
    console.error('You must provide a date value.')
    return
  }

  if (date?.length <= 10) {
    date = date?.replace("-", "/").replace("-", "/").replace("-", "/")
  }
  if (typeof date === "string") {
    date = date?.replace("Z", "")
  }

  if (isValid(date)) {
    return format(date, targetFormat)
  }

  if (isValid(new Date(date))) {
    return format(new Date(date), targetFormat)
  }

  console.error('Invalid date value')
}

export function getBackendDate(frontendDate, time = true) {
  if (!frontendDate || typeof frontendDate !== 'string') {
    console.error('You need to provide a valid date string format')
    return ''
  }

  const dataArr = frontendDate.split('/')

  if (time) {
    return `${dataArr[2]}-${dataArr[1]}-${dataArr[0]} 00:00:00`
  }
  return `${dataArr[2]}-${dataArr[1]}-${dataArr[0]}`
}

export const useQuery = (search) => {
  // const { search } = useLocation();
  return new URLSearchParams(search)
}

export function parseCpf(v) {
  v = v.replace(/\D/g, "")                    //Remove tudo o que não é dígito
  v = v.replace(/(\d{3})(\d)/, "$1.$2")       //Coloca um ponto entre o terceiro e o quarto dígitos
  v = v.replace(/(\d{3})(\d)/, "$1.$2")       //Coloca um ponto entre o terceiro e o quarto dígitos
                                           //de novo (para o segundo bloco de números)
  v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2") //Coloca um hífen entre o terceiro e o quarto dígitos
  return v
}

export function getDaysFromToday(date) {
  return Math.round((new Date() - new Date(date)) / (1000 * 60 * 60 * 24))
}

// Converte um número em texto para Number aceitando o padrão brasileiro
// ("1.234,56", "417580,58", "R$ 90,00") além do formato do banco ("1234.56").
// Devolve null quando não há número reconhecível no valor.
export const parseNumberBr = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  if (typeof value !== 'string') return null

  const limpo = value.replace(/[^\d,.-]/g, '')
  if (!/\d/.test(limpo)) return null

  const virgula = limpo.lastIndexOf(',')
  const ponto = limpo.lastIndexOf('.')

  let normalizado = limpo
  if (virgula !== -1 && ponto !== -1) {
    // O separador decimal é o que aparece por último; o outro é o de milhar.
    normalizado =
      virgula > ponto
        ? limpo.replace(/\./g, '').replace(',', '.')
        : limpo.replace(/,/g, '')
  } else if (virgula !== -1) {
    normalizado = limpo.replace(',', '.')
  } else if (/^-?\d{1,3}(\.\d{3})+$/.test(limpo)) {
    // Só pontos, todos em grupos de três: milhar sem casas decimais.
    normalizado = limpo.replace(/\./g, '')
  }

  const numero = Number(normalizado)
  return Number.isFinite(numero) ? numero : null
}

export const formatToCurrency = (value, locale = 'pt-BR', currency = 'BRL') => {
  const numero = parseNumberBr(value)

  // Sem número reconhecível não há moeda a exibir: passar o valor cru ao Intl
  // imprime "R$ NaN" na ficha, que é pior do que não mostrar nada.
  if (numero === null) return ''

  const formatting = { style: 'currency', currency }

  return new Intl.NumberFormat(locale, formatting).format(numero)
}

export const getMinutesDiff = (dateTimeValue2, dateTimeValue1) => {
  let differenceValue = (dateTimeValue2.getTime() - dateTimeValue1.getTime()) / 1000
  differenceValue /= 60
  return Math.abs(Math.round(differenceValue))
}

export const mockCardUrl = (id, ficha, hideBar) => {
  if (!!id && !!ficha) {
    return `${hideBar ? '' : '/'}cliente?id=${btoa(id)}&id_ficha=${btoa(ficha)}`
  }

  if (!!id) {
    return `${hideBar ? '' : '/'}cliente?id=${btoa(id)}`
  }

  return '#'
}

export const mockBiUrl = (id) => {
  console.log(id)
  
  if (!id) return '#'

  return `/dashboard/${btoa(id)}`
}

export const normalizeNumberPayload = (valor) => {
  if (valor === null) return '' // null ou undefined
  return String(valor).replace(/\./g, '').replace(/,/g, '.')
}

export const normalizeNumberGetOld = (valor) => {
  if (valor === null || valor === undefined) return ''

  const numero = Number(valor)
  if (isNaN(numero)) return valor

  return numero.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
export const formattedType = (value, formato) => {
  switch (formato) {
    case 'moeda':
      return formatToCurrency(value)
    case 'data':
      const data = dayjs(value).format(`DD/MM/YYYY`) || ''
      if (data === 'Invalid Date') {
        return ''
      } else {
        return data
      }
    case 'texto_simples':
      return value
    case 'numero':
      return value
    case 'porcentagem':
      return `${value} %`
    case 'data_hora':
      return dayjs(value).format(`DD/MM/YYYY HH:mm:ss`)
    case 'duracao':
      return value
    case 'hora':
      return dayjs(value).format(`HH:mm:ss`)
    case 'documento':
      return cpfCnpjMask(value)

    default:
      break
  }
  return value
}

export const formatPhoneNumber = (numero) => {
  if (!numero) return null
  // Remove qualquer caractere que não seja número
  const cleaned = numero?.replace(/\D/g, '')

  // Verifica se o número tem o tamanho esperado
  if (cleaned.length !== 13) return numero

  const pais = cleaned.slice(0, 2)        // 55
  const ddd = cleaned.slice(2, 4)         // 61
  const prefixo = cleaned.slice(4, 9)     // 98950
  const sufixo = cleaned.slice(9)         // 0127

  return `+${pais} (${ddd})${prefixo}-${sufixo}`
}

